import React from 'react';
import { motion } from 'framer-motion';

const Iletisim = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Delays between animations for smoothness
            },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 }, // Smooth entrance from below
        visible: { 
            opacity: 1, 
            y: 0,
            transition: { 
                duration: 0.8, // Smooth and slow animation
                ease: [0.42, 0, 0.58, 1], // Smooth easing
            },
        },
    };

    return (
        <motion.div 
            className='grid grid-cols-10 w-full pt-10 pb-20'
            initial="hidden"
            animate="visible"
            variants={containerVariants}
        >
            <div className='col-start-2 col-span-8 flex flex-col h-full w-full'>
                <motion.h1 
                    className='text-4xl font-medium text-black mb-10'
                    variants={itemVariants}
                >
                    İletişim
                </motion.h1>

                <iframe 
                 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3918.5824722037387!2d29.0519109!3d37.8303564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14c7151657f5cdaf%3A0x3fe77d209404fb69!2sTurkuaz%20Medikal%20Tekstil!5e1!3m2!1sen!2str!4v1729665653371!5m2!1sen!2str"
                    width="100%" 
                    height="450"  
                    allowFullScreen="" 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                    className="mb-10"
               
                ></iframe>

                <motion.div className='grid grid-cols-2 md:grid-cols-4' variants={containerVariants}>
                    <motion.div className='space-y-5 mt-5' variants={itemVariants}>
                        <motion.a href='https://maps.app.goo.gl/vwD49SUG6KsZnZMW8' target='_blank' className='block opacity-65 hover:opacity-100 transition-all duration-300'>
                            Akçeşme, 2053. Sok. No: 3, 20020 Merkezefendi/Denizli
                        </motion.a>
                        <motion.a href='tel:+902583717453' target='_blank' className='block opacity-65 hover:opacity-100 transition-all duration-300'>
                            +90 258 371 74 53
                        </motion.a>
                        <motion.a href='mailto:info@turkuazmedicals.com' target='_blank' className='block opacity-65 hover:opacity-100 transition-all duration-300'>
                            info@turkuazmedicals.com
                        </motion.a>
                        <motion.a  href='https://maps.app.goo.gl/vwD49SUG6KsZnZMW8' target='_blank' className='bg-turkuaz-blue text-white w-full flex items-center justify-center py-4 opacity-80 hover:opacity-100 transition-all duration-300'>
                            YOL TARİFİ AL
                        </motion.a>
                    </motion.div>
                </motion.div>
            </div>
        </motion.div>
    );
};

export default Iletisim;
